


































































import LeftMenu from '@/components/menus/LeftMenu.vue'
import { Vue, Component } from 'vue-property-decorator'
import MenuItem from '../../../models/menu-item.model'
@Component({
    components: {
        LeftMenu
    }
})
export default class MenuPreviewForm extends Vue {
    items: MenuItem[] = []

    loading = true

    originalMenu = {}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formData: {[key: string]: any} = {}
    formValid = false
    formRules = {
        menuName: [
            (v: string) => !!v || 'Name is required',
            (v: string) => (v && v.length <= 50) || 'Name must be less than 50 characters'
        ],
        description: [
            (v: string) => !!v || 'Description is required',
            (v: string) => (v && v.length <= 50) || 'Name must be less than 50 characters'
        ],
        menuTypeId: [
            (v: string) => !!v || 'Type is required'
        ]
    }

    formModel: {[key: string]: object[]} = {
        menuTypes: []
    }

    sidemenuItems = [ // Placeholder
        { title: 'Dashboard', icon: 'mdi-view-dashboard' },
        { title: 'Photos', icon: 'mdi-image' },
        { title: 'About', icon: 'mdi-help-box' }
    ]

    mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not action sended in route params :(' })
            return
        }

        switch (this.$route.params.action) {
        case 'edit':
            this.getData()
            break
        case 'add':
            this.originalMenu = {
                menuName: 'New Menu',
                description: '',
                menuEnabled: 0
            }
            this.loading = false
            break
        }
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
            this.loading = false
            return
        }
        this.$store.dispatch('getMenuById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.MenuStore.menuForm
                    this.originalMenu = { ...this.formData }
                    this.loading = false
                }
            })
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return
        switch (this.$route.params.action) {
        case 'edit':
            this.$store.dispatch('editMenu', this.formData)
                .then(resp => {
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Menus'
                        })
                    }
                })
            break
        case 'add':
            this.$store.dispatch('createMenu', this.formData)
                .then(resp => {
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Menus'
                        })
                    }
                })
            break
        }
    }
}
